module.exports = __webpack_public_path__ + "static/bringing-soldiers-home-bc55cf04407d5ab3beb042d66758285b.jpg";